module.exports = __webpack_public_path__ + "img/TailWing-Info.a627d7ed.jpg";